/**
 * XVELO Navigation Bar JavaScript
 * Handles desktop mega menu and mobile drawer interactions
 */

(function() {
  'use strict';

  function initXveloNav() {
    // ========== DESKTOP ==========

    // 1. Sticky shadow + mega menu positioning
    const nav = document.getElementById('xvSiteNav');
    if (!nav) {
      // Nav not found, retry later (for Shopify theme editor)
      setTimeout(initXveloNav, 100);
      return;
    }

    const megaMenus = document.querySelectorAll('.xv-mega-menu');
    const supportDropdown = document.querySelector('.xv-support-dropdown');

    function updateMenuPositions() {
      const topPos = nav.getBoundingClientRect().bottom + 'px';
      megaMenus.forEach(m => m.style.top = topPos);
      if (supportDropdown) supportDropdown.style.top = topPos;
    }

    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 10);
      updateMenuPositions();
    });

    window.addEventListener('resize', updateMenuPositions);
    updateMenuPositions();

    // 2. Category hover → 切换右侧产品面板 + 更新 View All 链接
    const catLinks = document.querySelectorAll('.xv-mega-menu__cat-link');
    console.log('[xvelo] cat-links found:', catLinks.length);
    catLinks.forEach(link => {
      console.log('[xvelo] cat-link:', link.dataset.collection, link.dataset.url);
      link.addEventListener('mouseenter', function() {
        const megaMenu = this.closest('.xv-mega-menu');
        if (!megaMenu) return;

        const handle = this.dataset.collection;
        const url    = this.dataset.url;
        console.log('[xvelo] hover handle:', handle);

        // 更新左侧高亮
        megaMenu.querySelectorAll('.xv-mega-menu__cat-link')
          .forEach(l => l.classList.remove('active'));
        this.classList.add('active');

        // 切换右侧产品面板
        const panels = megaMenu.querySelectorAll('.xv-mega-menu__products');
        console.log('[xvelo] panels found:', panels.length);
        panels.forEach(panel => {
          console.log('[xvelo] panel data-collection:', panel.dataset.collection, '=== handle?', panel.dataset.collection === handle);
          panel.classList.toggle('active', panel.dataset.collection === handle);
        });

        // 更新 "View All" 链接
        const viewAll = megaMenu.querySelector('.xv-mega-menu__view-all');
        if (viewAll && url) viewAll.href = url;
      });
    });

    // 3. Background overlay
    const overlay = document.getElementById('xvMegaOverlay');
    if (overlay) {
      document.querySelectorAll('.xv-site-nav__item').forEach(item => {
        if (item.querySelector('.xv-mega-menu') || item.querySelector('.xv-support-dropdown')) {
          item.addEventListener('mouseenter', () => overlay.classList.add('active'));
          item.addEventListener('mouseleave', () => overlay.classList.remove('active'));
        }
      });
    }

    // ========== MOBILE ==========

    // 4. Drawer open/close
    const hamburger = document.getElementById('xvHamburgerBtn');
    const drawer = document.getElementById('xvMobileDrawer');
    const drawerOverlay = document.getElementById('xvDrawerOverlay');
    const drawerClose = document.getElementById('xvDrawerClose');

    function openDrawer() {
      if (drawer) {
        drawer.classList.add('active');
        drawer.setAttribute('aria-hidden', 'false');
      }
      if (drawerOverlay) drawerOverlay.classList.add('active');
      if (hamburger) {
        hamburger.classList.add('active');
        hamburger.setAttribute('aria-expanded', 'true');
      }
      document.body.classList.add('xv-mobile-open');
    }

    function closeDrawer() {
      if (drawer) {
        drawer.classList.remove('active');
        drawer.setAttribute('aria-hidden', 'true');
      }
      if (drawerOverlay) drawerOverlay.classList.remove('active');
      if (hamburger) {
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
      }
      document.body.classList.remove('xv-mobile-open');
    }

    if (hamburger) {
      // Remove any existing listeners (for re-initialization)
      hamburger.replaceWith(hamburger.cloneNode(true));
      const newHamburger = document.getElementById('xvHamburgerBtn');

      newHamburger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = drawer && drawer.classList.contains('active');
        isOpen ? closeDrawer() : openDrawer();
      });
    }

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      });
    }

    // 5. Accordion menu
    document.querySelectorAll('.xv-m-nav-link[data-toggle]').forEach(link => {
      // Remove existing listeners
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);

      newLink.addEventListener('click', function(e) {
        e.preventDefault();
        const parent = this.closest('.xv-m-nav-item');
        if (!parent) return;

        const wasOpen = parent.classList.contains('open');

        // Close other open items
        document.querySelectorAll('.xv-m-nav-item.open').forEach(item => {
          if (item !== parent) item.classList.remove('open');
        });

        parent.classList.toggle('open', !wasOpen);
      });
    });

    // 6. Language toggle (mobile)
    document.querySelectorAll('.xv-m-lang-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.xv-m-lang-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        // TODO: Integrate Shopify multi-language switching
      });
    });

    // ========== SEARCH DROPDOWN ==========
    const searchToggle = document.getElementById('xvSearchToggle');
    const searchDropdown = document.getElementById('xvSearchDropdown');
    const searchInput = document.getElementById('xvSearchInput');
    const searchClear = document.getElementById('xvSearchClear');

    function openSearch() {
      if (searchDropdown) {
        searchDropdown.classList.add('active');
        searchToggle?.setAttribute('aria-expanded', 'true');
        // Focus input after animation
        setTimeout(() => searchInput?.focus(), 100);
      }
      // Close language dropdown if open
      closeLang();
    }

    function closeSearch() {
      if (searchDropdown) {
        searchDropdown.classList.remove('active');
        searchToggle?.setAttribute('aria-expanded', 'false');
      }
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = searchDropdown?.classList.contains('active');
        isOpen ? closeSearch() : openSearch();
      });
    }

    // Clear button
    if (searchClear && searchInput) {
      searchInput.addEventListener('input', () => {
        searchClear.style.display = searchInput.value.length > 0 ? 'flex' : 'none';
      });

      searchClear.addEventListener('click', (e) => {
        e.preventDefault();
        searchInput.value = '';
        searchClear.style.display = 'none';
        searchInput.focus();
      });
    }

    // ========== LANGUAGE DROPDOWN ==========
    const langToggle = document.getElementById('xvLangToggle');
    const langDropdown = document.getElementById('xvLangDropdown');

    function openLang() {
      if (langDropdown) {
        langDropdown.classList.add('active');
        langToggle?.setAttribute('aria-expanded', 'true');
      }
      // Close search dropdown if open
      closeSearch();
    }

    function closeLang() {
      if (langDropdown) {
        langDropdown.classList.remove('active');
        langToggle?.setAttribute('aria-expanded', 'false');
      }
    }

    if (langToggle) {
      langToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = langDropdown?.classList.contains('active');
        isOpen ? closeLang() : openLang();
      });
    }

    // ========== CLICK OUTSIDE TO CLOSE ==========
    document.addEventListener('click', (e) => {
      // Close search if clicking outside
      if (searchDropdown?.classList.contains('active')) {
        const searchWrapper = e.target.closest('.xv-search-wrapper');
        if (!searchWrapper) closeSearch();
      }

      // Close language if clicking outside
      if (langDropdown?.classList.contains('active')) {
        const langWrapper = e.target.closest('.xv-lang-wrapper');
        if (!langWrapper) closeLang();
      }
    });

    // Close dropdowns on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeSearch();
        closeLang();
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initXveloNav);
  } else {
    // DOM is already loaded
    initXveloNav();
  }

  // Re-initialize when Shopify theme editor updates the section
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initXveloNav);
    document.addEventListener('shopify:section:unload', initXveloNav);
  }
})();
